var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"strip"}),_c('iframe',{attrs:{"height":"100%","width":"200%","src":("" + (this.path +'?file=' + this.fileName))}})])}
var staticRenderFns = []

export { render, staticRenderFns }